<template>
	<div class="card col-md-12 mx-auto">
		<div class="card-header card-header bg-primary text-white h4 m-0">
			<page-title :title="roleName + ' / ' + ($t(titleKey))"></page-title>
		</div>

		<div class="card-body" v-if="hasItems" v-cloak>
			<div v-cloak>
				<div class="btn-group" role="group">
					<button type="button" class="btn btn-primary" @click="redirectToList">
						<i class="fas fa-th-list"></i>
						{{ $t('backToList') }}
					</button>
				</div>
				<div class="input-group col-sm-4 col-md-3 float-right btn-group">
					<div class="input-group-addon fas fa-search text-primary" style="display:table-cell"></div>
					<input class="form-control fa fa-search" name="query" v-model="searchQuery" />
				</div>
			</div>
			<custom-grid :data="claims"
				:columns="gridColumns"
                :html-columns="['description']"
				:filter-key="searchQuery"
				:captions="gridCaptions"
				:gridName="'RoleClaims'"
				:readonly="!hasEditRights || working"
                :btns="btns">
            </custom-grid>
		</div>
		<div class="card-body" v-else v-cloak>
			<div class="alert alert-warning" role="alert">
				<h4>Липсват данни.</h4>
			</div>
		</div>
        <UpdateModal v-model="updateModel" :show="showUpdate" @onClose="onUpdateClose" @updated="onUpdate"></UpdateModal>
	</div>
</template>

<script>
import CustomGrid from '@/components/grid/CustomGrid';
import PageTitle from '@/components/common/PageTitle';
import bus from '@/components/sidemenu/event-bus';
import UpdateModal from '@/components/administration/role/update.modal.vue';
import { Culture } from '@/models/enums';


export default {
	components: {
		CustomGrid,
		PageTitle,
        UpdateModal
	},
	props: {
		id: String
	},
	created() {
		this.bus = bus;
		this.bus.$on('checkbox-changed', (claim, gridName) => {
			if (gridName === 'RoleClaims') {
				if (
					this.id &&
					claim.hasOwnProperty('roleId') &&
					claim.hasOwnProperty('claimId') &&
					claim.claimId > 0 &&
					this.id === claim.roleId
				) {
					this.toggleRoleClaim(claim);
				}
			}
		});
	},
	beforeDestroy() {
		this.bus.$off('checkbox-changed');
	},
	data() {
		return {
			componentName: 'RoleClaimsList',
			titleKey: 'sideMenu.roles', // Трабва на конпонентата за бутоните за дашборд настройките
			loading: false,
			working: false,
            showUpdate: false,
            updateModel: null,
			gridCaptions: {
				roleClaimId: 'editor.common.id',
				claimName: 'editor.common.name',
				claimNormalizedName: 'editor.common.normalizedName',
				claimLabel: 'editor.common.label',
				claimLabelEn: 'editor.common.labelEn',
				description: 'editor.common.description',
				create: 'editor.common.create',
				read: 'editor.common.read',
				update: 'editor.common.update',
				delete: 'editor.common.delete'
			},
			claims: [
				{
					roleClaimId: 0,
					claimId: 0,
					claimName: '',
					claimNormalizedName: '',
					claimLabel: '',
					claimLabelEn: '',
					claimDeactivated: false,
					ClaimNote: '',
					roleId: '',
					userId: '',
					roleName: '',
					roleDescription: '',
					uuserName: '',
					create: false,
					read: false,
					update: false,
					delete: false
				}
			],
			searchQuery: '',
			roleName: '',
			roleDescription: '',
            btns: [{
                name: 'claimDescriptionUpdate',
                text: '',
                tooltip: this.$t('buttons.links.tooltipText'),
                class: 'btn btn-success',
                icon: 'fas fa-edit',
                show: this.$store.getters.claims.claimsAdministration.update,
                clickHandler: this.showUpdateModal
            }],
		};
	},
	methods: {
		loadData: function() {
			this.loading = true;

			return this.$http
				.get(`/api/roles/listClaims/${this.id}`)
				.then(response => {
					this.claims = response.data.claims;
					this.roleName = response.data.roleName;
					this.roleDescription = response.data.roleDescription;

					this.loading = false;
				})
				.catch(error => {
					this.$vs.notify({
						title: this.$t(
							'request.response.status.' +
								this.$helpers.errorStatusCode(error)
						),
						text: this.$helpers.errorText(error),
						color: 'danger',
						time: this.$store.getters.notificationDuration
					});

					this.loading = false;
				});
		},
		toggleRoleClaim(claim) {
            if (!this.hasEditRights) {
				return this.$router.push(`/unauthorized`);
            }

			this.working = true;
			this.$http
				.post(`/api/roles/toggleClaim`, claim)
				.then(response => {
					this.$vs.notify({
						title: this.$t('buttons.save.btnText'),
						text: this.$helpers.responseMessage(response),
						color: 'success',
						time: this.$store.getters.notificationDuration,
						position: 'top-center'
					});
				})
				.catch(error => {
					this.$vs.notify({
						title: this.$t('buttons.save.btnText'),
						text: this.$helpers.errorText(error),
						color: 'danger',
						time: this.$store.getters.notificationDuration,
						position: 'top-center'
					});
				})
				.then(() => { this.working = false; });
		},
		redirectToList() {
            this.$router.push({ path: '/administration/usergroups' });
		},
        showUpdateModal(args) {
            console.log(args);
            this.updateModel = { ...args };
            this.showUpdate = true;
        },
        onUpdateClose() {
            this.showUpdate = false;
            this.updateModel = null;
        },
        onUpdate() {
            this.loadData();
        },
	},
	mounted: function() {
		if (!this.isNew) {
			this.loadData();
		}

		var container = $(this.$el);
		container.find('[data-toggle="tooltip"]').tooltip({ container });
	},
	computed: {
		token: function() {
			return this.$store.getters.authToken;
		},
		hasItems() {
			return Array.isArray(this.claims) && this.claims.length;
		},
		isNew: function() {
			return this.id === undefined;
		},
		isEnVersion() {
			return this.$store.getters.currentCulture === Culture.EN;
		},
		hasEditRights() {
            return this.$store.getters.claims.claimsAdministration.update;
		},
        gridColumns() {
            if (this.isEnVersion) {
				return [
				'claimName',
				'claimLabelEn',
				'description',
				'create',
				'read',
				'update',
				'delete']
            } else {
				return [
				'claimName',
				'claimLabel',
				'description',
				'create',
				'read',
				'update',
				'delete']
            }
		}
	}
};
</script>

<style scoped>
</style>
